/**
 * Translation engine for svenska_roster frontend.
 * Supports {placeholder} interpolation.
 */
import sv from './sv.json';
import fi from './fi.json';
import en from './en.json';

const translations = { sv, fi, en };

export const SUPPORTED_LANGUAGES = [
  { code: 'sv', label: 'Svenska' },
  { code: 'fi', label: 'Suomi' },
  { code: 'en', label: 'English' },
];

export const DEFAULT_LANGUAGE = 'sv';

/**
 * Translate a key with optional parameter interpolation.
 * @param {string} lang - Language code ('sv', 'fi', 'en')
 * @param {string} key - Dot-notated translation key
 * @param {Object} [params] - Interpolation values, e.g. { count: 5, name: 'Anna' }
 * @returns {string} Translated string, or the key itself as fallback
 */
export function translate(lang, key, params = {}) {
  const dict = translations[lang] || translations[DEFAULT_LANGUAGE];
  let text = dict[key];

  // Fallback to Swedish, then to key itself
  if (text === undefined) {
    text = translations[DEFAULT_LANGUAGE][key];
  }
  if (text === undefined) {
    return key;
  }

  // Interpolate {placeholder} tokens
  if (params && typeof text === 'string') {
    for (const [k, v] of Object.entries(params)) {
      text = text.replace(new RegExp(`\\{${k}\\}`, 'g'), String(v));
    }
  }

  return text;
}

export default translate;
